import { SalesOrganization, UserContext } from "./user-context.model";

export const MOCK_SALES_ORGANIZATIONS: SalesOrganization[] = [
  {
    id: "0600",
    countries: ["DE"],
    allowedLanguages: ["en", "de", "fr", "nl"],
  },
  {
    id: "0800",
    countries: ["FR"],
    allowedLanguages: ["en", "fr"],
  },
  {
    id: "2900",
    countries: ["AT"],
    allowedLanguages: ["en", "de"],
  },
];

export const MOCK_USER_CONTEXT: UserContext = {
  id: "mock-user-1",
  name: "Max Mustermann",
  email: "max.mustermann@claas.com",
  salesOrganizations: MOCK_SALES_ORGANIZATIONS,
};

export const MOCK_DEFAULT_COUNTRY = "DE";
export const MOCK_DEFAULT_LANGUAGE = "de";

/** Returns the SalesOrganization that owns the given country, or undefined. */
export function findSalesOrgForCountry(
  salesOrgs: SalesOrganization[],
  country: string,
): SalesOrganization | undefined {
  return salesOrgs.find((org) => org.countries.includes(country));
}

/** Returns all unique countries available across the given sales organizations. */
export function getAllAvailableCountries(
  salesOrgs: SalesOrganization[],
): string[] {
  return [...new Set(salesOrgs.flatMap((org) => org.countries))];
}

/** Returns the first allowed language for the given country. */
export function getFirstAllowedLanguage(
  salesOrgs: SalesOrganization[],
  country: string,
): string {
  const org = findSalesOrgForCountry(salesOrgs, country);
  return org?.allowedLanguages[0] ?? MOCK_DEFAULT_LANGUAGE;
}
